import { useChecklistContext } from '../../../../contexts';
import { ChecklistSection } from '../../ChecklistPage';
import { PaddedGenericSection } from '../GenericSection';

export const BankruptcyCheckRefName = 'bankruptcy-check';

export default function BankruptcySection() {
  const { checklist } = useChecklistContext();

  const { bankruptcyChecks } = checklist ?? {};

  return (
    <PaddedGenericSection
      refName={BankruptcyCheckRefName}
      section={ChecklistSection.BANKRUPTCY}
      subSection={ChecklistSection.NOTES_BANKRUPTCY}
      checklistItem={bankruptcyChecks}
    >
      <p>level 0</p>
    </PaddedGenericSection>
  );
}
